@use "Styles/mixins";

:host {
    display: contents;
}

// All of the lightbox-specific dialog styling sits here — vm-modal's `unstyled` variant
// just strips chrome and provides a sensible-default backdrop; we layer sizing + the
// close-button overlay on top via `::part()`.
vm-modal[variant="unstyled"] {
    // Full-bleed on mobile; on tablet+ the dialog wraps the image at natural size
    // (capped at 90vw/90vh). `fit-content` because the UA `<dialog>` stylesheet sets
    // `inset-inline: 0`, so `auto` would stretch the dialog edge-to-edge.
    &::part(modal) {
        width: 100vw;
        height: 100vh;
        height: 100dvh;
        max-width: 100vw;
        max-height: 100vh;
        max-height: 100dvh;

        @include mixins.tablet-and-up {
            width: fit-content;
            height: fit-content;
            max-width: 90vw;
            max-height: 90vh;
            max-height: 90dvh;
        }
    }

    // vm-modal's container (between the dialog and the body) is a flex column with
    // auto height, so on the full-bleed mobile dialog it collapses to the image
    // height and pins the image to the top. Stretch it to fill the dialog so the
    // body's grid centering has the whole viewport to centre within. On tablet+
    // the dialog is `fit-content`, so the container goes back to hugging the image.
    &::part(container) {
        height: 100%;

        @include mixins.tablet-and-up {
            height: auto;
        }
    }

    // Body fills the dialog and becomes the positioning context for our absolute close
    // button. Grid-centers the surface; the close button is taken out of flow.
    &::part(body) {
        overflow: hidden;
        display: grid;
        place-items: center;
        position: relative;
    }
}

.vm-image-lightbox {
    // Translucent-white pill with a dark X. Floats in the top-right corner of the dialog
    // (image's top-right on desktop, since the dialog wraps the image). vm-modal's
    // `unstyled` variant doesn't render its built-in X, so we own this entirely.
    // Positioning sits on the host; the pill visual lands on the inner ::part(button).
    &__close {
        position: absolute;
        top: max(16px, env(safe-area-inset-top));
        right: max(16px, env(safe-area-inset-right));
        z-index: 1;

        &::part(button) {
            padding: 8px;
            background: mixins.get-color(background, bg-white-alpha70);
            border: none;
            border-radius: 100px;
            color: mixins.get-color(text, text-black);
        }
    }

    &__surface {
        width: 100%;
        height: 100%;
        display: grid;
        place-items: center;
        touch-action: none;
    }

    &__image {
        max-width: 100vw;
        max-height: 100vh;
        max-height: 100dvh;
        object-fit: contain;
        user-select: none;
        transform-origin: center;
        will-change: transform;

        @include mixins.tablet-and-up {
            max-width: 90vw;
            max-height: 90vh;
            max-height: 90dvh;
        }
    }
}
